import { PrevStepButton, CloseModalButton } from '@common/components/BookingForms';
import { getDetailQuery, getDetailRoute } from '@features/rates/helpers/bookingRoutes.helper';
import { useRouter } from 'shared-routing';
import { DisplayCurrentStep } from '../../FormSteps/DisplayCurrentStep';
import { usePreviousStep } from './usePreviousStep';
import { StepType, StepTypeWithIndex } from '../../types';

export const StepNavigator = (
  rateCode: string,
  currentStep: StepTypeWithIndex,
  steps: StepType[]
) => {
  const router = useRouter();

  const goToPreviousStep = usePreviousStep(rateCode, currentStep);

  return (
    <>
      <PrevStepButton onClick={goToPreviousStep} />
      <DisplayCurrentStep steps={steps} currentStep={currentStep.type} />
      <CloseModalButton
        onClick={() =>
          router.push({
            pathname: getDetailRoute(router.pathname),
            query: getDetailQuery(router.query, rateCode),
          })
        }
      />
    </>
  );
};
